import React from 'react';
import { Card, CardHeader, Row } from 'reactstrap';
import UserData from '../UserData';
import '../../styles/ConfirmationStep.css';


class ConfirmationStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {checked: false,
        cancel: false,
        agreement: false,
        submitted: false
    };
        this.missingError= "Wir benötigen ihr Einverständnis, bitte überprüfen sie ihre Eingabe";
        this.handleChangeChecked = this.handleChangeChecked.bind(this);
        this.handleChangeCancel = this.handleChangeCancel.bind(this);
        this.handleChangeAgreement = this.handleChangeAgreement.bind(this);
    }

    isValidated() {
        this.setState({
            submitted: true});
        if (this.props.isRegistration) {
            if (this.state.checked === true && this.state.cancel === true && this.state.agreement === true) {
                return true;
            }
            else {
                return false;
            }
        }
        else { 
            return true;
        }

    }

    handleChangeChecked(event) {
        this.setState({
            checked: !this.state.checked});
      }
      handleChangeCancel(event) {
        this.setState({
            cancel: !this.state.cancel});
      }
      handleChangeAgreement(event) {
        this.setState({
            agreement: !this.state.agreement});
      }

    render(){
        let checkedmsg;
        let cancelmsg;
        let agreemsg
        if (this.state.submitted) {
            if (this.state.checked === false) {
                checkedmsg=
                        <span id="span" className="help-block">{this.missingError}</span>
            }
            if (this.state.cancel === false) {
                cancelmsg=
                        <span id="span" className="help-block">{this.missingError}</span>
            }
            if (this.state.agreement === false) {
                agreemsg=
                        <span id="span" className="help-block">{this.missingError}</span>
            }
        }
        let checkboxes;
        var headline= '';
        var text= '';
        let links;
        if ( this.props.isRegistration ) {
          headline= 'Übersicht GASAG | Leerstand anmelden.';
          text = 'Für folgende Verbrauchsstellen beauftragen Sie die GASAG AG mit der Belieferung mit dem Produkt GASAG | Leerstand.'
          checkboxes =  
          <div>
            <Row>
                <label id="label2">
                    <input id="checkbox2" type="checkbox" checked={this.state.checked} name="checked" onChange={this.handleChangeChecked} />
                        Es gelten die "Allgemeinen Geschäftsbedingungen GASAG | Leerstand". Ich habe diese zur Kenntnis genommen und erkläre mich damit einverstanden,
                        diese zum Vertragsbestandteil zu machen. Informationen zu Streitbeilegungsverfahren und Einrichtungen für Verbraucherbeschwerden 
                        finde ich in § 18 der AGB. Ich habe die Datenschutzhinweise zur Kenntnis genommen.
                </label>
                {checkedmsg}
            </Row>
            <Row>
                <label id="label2">
                    <input id="checkbox2" type="checkbox" checked={this.state.cancel} name="cancel" onChange={this.handleChangeCancel} />
                        Ich habe die Widerrufsbelehrung zur Kenntnis genommen.
                </label>
                {cancelmsg}
            </Row>
            <Row>
                <label id="label2">
                    <input id="checkbox2" type="checkbox" checked={this.state.agreement} name="agreement" onChange={this.handleChangeAgreement} />
                        Ich beauftrage die GASAG mit der Belieferung für die oben genannte(n) Verbrauchsstelle(n) zu den unten genannten Konditionen. 
                        Ich bin damit einverstanden, dass die GASAG zur Bonitätsprüfung Auskünfte bei einer Wirtschaftsauskunft einholt und 
                        zu diesem Zwecke meine personenbezogenen Daten an diese übermittelt.
                </label>
                {agreemsg}
            </Row>
        </div>
        }
        if (this.props.isRegistration && this.props.type === 'electricity') {
            if (this.props.additionalGas) {
                links= 
                    <div>
                        <hr></hr>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/agb/GASAG-STROM-Leerstand-AGB.ashx" >AGB und Datenschutzhinweise – GASAG | STROM Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/preisblaetter/GASAG-STROM-Leerstand-Preisblatt.ashx">Preisblatt – GASAG | STROM Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/stromkennzeichnungen/gasag-stromkennzeichnung.ashx">GASAG-Stromkennzeichnung</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/agb/GASAG-Erdgas-Leerstand-AGB.ashx">AGB und Datenschutzhinweise – GASAG | ERDGAS Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/preisblaetter/GASAG-ERDGAS-Leerstand-Preisblatt.ashx">Preisblatt – GASAG | ERDGAS Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/privatkunden/service/service-siegel/beschwerdemanagement/widerrufsbelehrung">Zur Widerrufsbelehrung</a>
                        </Row>
                        <hr></hr> 
                    </div>
            } else {
                links=
                    <div>
                        <hr></hr>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/agb/GASAG-STROM-Leerstand-AGB.ashx" >AGB und Datenschutzhinweise – GASAG | STROM Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/preisblaetter/GASAG-STROM-Leerstand-Preisblatt.ashx">Preisblatt – GASAG | STROM Leerstand</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/stromkennzeichnungen/gasag-stromkennzeichnung.ashx">GASAG-Stromkennzeichnung</a>
                        </Row>
                        <Row>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/privatkunden/service/service-siegel/beschwerdemanagement/widerrufsbelehrung">Zur Widerrufsbelehrung</a>
                        </Row>
                        <hr></hr> 
                    </div>
            }
        }
        if (this.props.isRegistration && this.props.type === 'gas') {
            links=
            <div>
                <hr></hr>
                <Row>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/agb/GASAG-Erdgas-Leerstand-AGB.ashx">AGB und Datenschutzhinweise – GASAG | ERDGAS Leerstand</a>
                </Row>
                <Row>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/-/media/files/preisblaetter/GASAG-ERDGAS-Leerstand-Preisblatt.ashx">Preisblatt – GASAG | ERDGAS Leerstand</a>
                </Row>
                <Row>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.gasag.de/privatkunden/service/service-siegel/beschwerdemanagement/widerrufsbelehrung">Zur Widerrufsbelehrung</a>
                </Row>
                <hr></hr>
            </div>
        }
        if (!this.props.isRegistration) {
          headline= 'Übersicht GASAG | Leerstand abmelden.'
          text = 'Folgende Verbrauchsstellen melden wir für die Belieferung mit dem Produkt GASAG | Leerstand durch die GASAG AG ab.'
        }
        
    return (
    <div>
        <hr></hr>
        <h2>{headline}</h2>
        <h5>{text}</h5>
        <hr></hr>
        <Card>
            <CardHeader>
                Zusammenfassung:
            </CardHeader>
            <UserData isSummary={true} steps={this.props} />
        </Card>
       {checkboxes}
       {links}
    </div>
)};
}
export default ConfirmationStep;


// WEBPACK FOOTER //
// ./src/components/Steps/ConfirmationStep.js